<template>
	<div>
		<div>Document ID</div>
		<CombinedInputFieldDataMenu class="mb-6" :textAreaMode="true" :value.sync="docsId" :valuesTypes="dataInputMenuValueTypes" />
		<div>Controls</div>
		<h5>Customise editing experience</h5>
		<AppSelect
			v-model="rmParam"
			:items="rmParamOptions"
			item-title="text"
			item-value="value"
			label="Controls"
			single-line
			outlined
			dense
		></AppSelect>
		<div>Display mode</div>
		<AppSelect
			v-model="editMode"
			:items="displayModeOptions"
			item-title="text"
			item-value="value"
			label="Display Mode"
			single-line
			outlined
			dense
		></AppSelect>
		<div class="info-box">
			The feature user must have permission to edit the document. Tip: You can use the Drive action "Update file permissions".
		</div>
	</div>
</template>

<script>
import ItemOnlyAllowedValueTypesMixin from './ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';
import FieldSettingsMixin, { getComputedMetadataOption } from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';
import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';

export default {
	name: 'GoogleDocsFieldSettings',
	mixins: [FieldSettingsMixin, ItemOnlyAllowedValueTypesMixin],
	components: {
		CombinedInputFieldDataMenu,
	},
	computed: {
		docsId: getComputedMetadataOption('docs_id', 'value'),
		rmParam: getComputedMetadataOption('rm_param', 'value'),
		editMode: getComputedMetadataOption('edit_mode', 'value'),
	},
	data() {
		return {
			rmParamOptions: [
				{ text: 'Full controls', value: '' },
				{ text: 'Minimal', value: 'demo' },
				{ text: 'No controls', value: 'minimal' },
			],
			displayModeOptions: [
				{ text: 'Preview', value: 'preview' },
				{ text: 'Edit', value: 'edit' },
			],
		};
	},
	methods: {},
};
</script>

<style scoped>
div > .info-box {
	font-size: 12px;
	color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
	background-color: #f9fafc;
	padding: 10px;
	border-radius: 5px;
	margin-top: 20px;
}
</style>
